import React from 'react';
import InventoryMap from '@components/plots/inventory-map/inventory-map';

function Page() {
    return (
        <main className='relative w-screen p-4'>
            <InventoryMap />
        </main>
    );
}

export default Page;
